<template>
  <div class="agency-content">{{ userData.agency || "" }}</div>
</template>

<script>
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
  },
  props: {
  },
  data() {
    return {};
  },
  computed: {
    userData() {
      return this.$store.state.auth.currentUser || {};
    },
  },
  methods: {},
};
</script>
